module.exports = __webpack_public_path__ + "static/media/GBR Network (PPN Network) - 21-03-2025 N.a59dd150.gif";